import { jsx as _jsx } from "react/jsx-runtime";
import { useAttributeState } from './ZigbeeAttributesSlice';
import { renderAttributeValue } from '../../types/Zigbee/AttributeTypedValue';
export const ZigbeeAttributeValue = (props) => {
    const attr = useAttributeState(props.nid, props.eid, props.cid, props.aid);
    if (attr != undefined) {
        const val = renderAttributeValue(attr.typedValue);
        return (_jsx("span", { children: val }));
    }
    else {
        return (_jsx("span", { children: "?" }));
    }
};
